import React from 'react';
import { connect } from 'react-redux';
import { setDialogs, setBindCodeData } from '../../../actions';
import { post } from '../../../lib/kbApp/kbJsBridgePromise';
import { getHost } from '../../../const';
import { getWelfareCenterParams, loginAction } from '../../../rootStore';
import { ActionFalseDialog, OpenRedpackDialog } from '../../../components';
import bindRelationshipError from '../../../const/bindRelationshipError';
import './index.scss';

class InviteCodeDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      btnDisable: true,
    };
    this.Log = this.props.Log;
  }

  componentDidMount() {
  }

	close = () => {
	  this.props.dialogs.pop();
	  this.props.dispatch(setDialogs(this.props.dialogs));
	}

	// 输入邀请码
	onChangeWord = (e) => {
	  const { value } = e.target;

	  this.setState({
	    value: e.target.value,
	  });

	  if (value && value !== '' && /^[0-9a-zA-Z]{6,7}$/.test(value)) {
	    this.setState({
	      btnDisable: false,
	    });
	  } else {
	    this.setState({
	      btnDisable: true,
	    });
	  }
	}

	// 绑定邀请码
	bindRelationship = () => {
	  if (this.state.btnDisable) {
	    return;
	  }

	  const param = Object.assign(getWelfareCenterParams(), {
	    inviteCode: this.state.value || '',
	  });

	  post(`${getHost()}/newtickets/api/kuaibao/bindRelationshipByCode`, param).then((res) => {
	      this.props.dialogs.pop();
	      const len = this.props.dialogs.length;

	      if (res.code === 0) {
	        this.props.dispatch(setBindCodeData(res.data));
	        this.props.dispatch(setDialogs(this.props.dialogs.concat([
						<OpenRedpackDialog key={len} num={res.data.prenticeAmount / 100} desc="领取成功，已存入现金余额中" from="inviteCode" history={this.props.history}></OpenRedpackDialog>,
	        ])));

	        this.Log && this.Log.sendExposure({
	          element_type: 'invite',
	          element_name: 'bind_popup_success',
	        });
	      } else {
	        const msg = bindRelationshipError[res.code] ? bindRelationshipError[res.code] : res.msg;
	        this.props.dispatch(setDialogs(this.props.dialogs.concat([
						<ActionFalseDialog key={len} title="很抱歉，绑定失败" subTitle={msg} from="inviteCode" history={this.props.history}></ActionFalseDialog>,
	        ])));

	        this.Log && this.Log.sendExposure({
	          element_type: 'invite',
	          element_name: 'bind_popup_fail',
	        });
	      }
	    });
	}

	login = () => {
	  this.props.dialogs.pop();
	  loginAction();
	}

	contentRender = () => {
	  const { from } = this.props;

	  if (from === 'inviteCard') {
	    return (
				<React.Fragment>
					<div className="inviteDesc">绑定好友邀请码，领取现金</div>
					<div className="inputWrap">
						<input placeholder="粘贴邀请码" value={this.state.value} onChange={e => this.onChangeInput(e)}></input>
					</div>
					<div className={`withdraw ${this.state.btnDisable && 'disable'}`} onClick={() => this.bindRelationship()}>领取现金</div>
				</React.Fragment>
	    );
	  }
	  return (
				<React.Fragment>
					<div className="tip">
						<div className="desc">恭喜获得现金红包</div>
					</div>
					<div className="withdraw login-btn" onClick={() => this.login()} log-click-eltype="confirm">收下红包</div>
				</React.Fragment>
	  );
	}

	render() {
	  return (
			<div className="inviteCodeDialog">
				<div className="redpack">
					<div className="redpackGet">
						{this.contentRender()}
					</div>
					<div className="close" onClick={this.close} log-click-eltype="close"></div>
				</div>
			</div>
	  );
	}
}

const mapStateToProps = (state) => {
  const { dialogs } = state;
  return {
    dialogs,
  };
};

export default connect(mapStateToProps)(InviteCodeDialog);
